import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import JuniorHeader from'../Component/JuniorHeader'
const Curriculum = () => { 
    useEffect(() => {
        document.title = ' Curriculum - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <JuniorHeader/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Curriculum</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Curriculum</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <ul className="list newlist">
                     <li>In addition to the subjects prescribed by the council syllabus, the curriculum includes Religious instruction, (for Christians), Moral Science (for Non Catholics) and Value Education (for all) as compulsory subjects. </li> <li>Apart from these the curriculum may include Handicrafts, Singing, Project Work etc. </li>
                     <li>Bengali or Hindi as Second Language is taught from Class-I. </li>
                     </ul>
 </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Curriculum

